module.exports = __webpack_public_path__ + "static/media/maintenance.0579aa55.png";